import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { CfdiUsoService } from '../../../services/CfdiUsoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'cfdi_uso_clave',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. G03',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'cfdi_uso_nombre',
    label: 'Nombre',
    type: 'text',
    col: 8,
    placeholder: 'Ej. Gastos en general',
    validators: [
      Validators.required("El nombre es obligatorio")
    ],
  },
  {
    name: 'cfdi_uso_fisica',
    label: 'Aplica Física',
    type: 'select',
    col: 6,
    options: [{"value":"Si","label":"Sí"},{"value":"No","label":"No"}],
    validators: [
      Validators.required("Seleccione si aplica a persona física")
    ],
  },
  {
    name: 'cfdi_uso_moral',
    label: 'Aplica Moral',
    type: 'select',
    col: 6,
    options: [{"value":"Si","label":"Sí"},{"value":"No","label":"No"}],
    validators: [
      Validators.required("Seleccione si aplica a persona moral")
    ],
  },
];

export const CfdiUsoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await CfdiUsoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await CfdiUsoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Uso CFDI"
      subtitle="Catálogo de usos de CFDI autorizados por el SAT"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/CfdiUsos"
    />
  );
};

export default CfdiUsoForm;
